module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00070-fs8.0d48ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00070-fs8.png
// module id = 223
// module chunks = 0